import auth from "../modules/auth/routes";
import admin from "../modules/admin/routes";
import franchisee from "../modules/franchisee/routes";
import restaurant from "../modules/restaurant/routes";

export default [...admin, ...franchisee, ...restaurant, ...auth];
